var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('header',[_c('span',[_vm._v(_vm._s(_vm.title)+" ")])]),_c('main',[_c('Wallet')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }